module.exports = __webpack_public_path__ + "static/media/CVaHarrisJan2019.bd9b41c3.pdf";